const confirmForgotPasswordEN = {
	title: "Reset your password",
	subtitle: "Enter the confirmation code we sent you and choose a new password.",
	email: "Email address",
	code: "Confirmation code",
	password: "New password",
	confirmPassword: "Confirm password",
	submit: "Reset password",
	submitting: "Updating...",
	success: "Your password has been updated successfully.",
	toast: {
		required: "All fields are required.",
		weakPassword:
			"Password must be at least 8 characters and include an uppercase letter, a lowercase letter, a number, and a special character",
		mismatch: "Passwords do not match.",
		invalidCode: "Invalid or expired confirmation code.",
		error: "Could not reset password. Please try again.",
	},
};

export default confirmForgotPasswordEN;
